import Header3 from '../components/Header3';
import Footer3 from '../components/Footer3';
import { Helmet } from 'react-helmet';
import ApplicationContent from '../components/BannerBlocks/ApplicationContent';

function Application() {
    return (
        <>
            <Helmet>
                <title>{`Testfabrics.com: Application`}</title>
            </Helmet>
            <Header3 />
            <ApplicationContent/>
            <Footer3 />
        </>
    );
}

export default Application;
